import type { McpUiDisplayMode } from "@modelcontextprotocol/ext-apps";
import type { iAppConfig } from "../types/common";

export type McpWidgetKind = "hotel" | "flight" | "activity";

export const MCP_WIDGET_META_KEY = "ai.zenvoya/widget";

export const MCP_WIDGET_APP_INFO = { name: "zenvoya-widget", version: "1.0.0" };

export const MCP_WIDGET_DISPLAY_MODES: McpUiDisplayMode[] = ["inline", "fullscreen"];

export const MCP_FULLSCREEN_SETTLE_MS = 1000;

export const MCP_WIDGET_KIND_BY_TOOL: Record<string, McpWidgetKind> = {
  search_hotels: "hotel",
  search_flights: "flight",
  search_activities: "activity",
};

export const MCP_WIDGET_KINDS: McpWidgetKind[] = ["hotel", "flight", "activity"];

export const MCP_WIDGET_SKELETON_COUNT = 3;

export const MCP_WIDGET_SKELETON_FLIGHT_LEGS = 2;

export const MCP_WIDGET_TOOLS = {
  rooms: "get_hotel_rooms",
  fares: "get_flight_fares",
  reviews: "get_hotel_reviews",
  book: "start_booking",
} as const;

export const MCP_WIDGET_CONTEXT_TOOLS: string[] = [MCP_WIDGET_TOOLS.rooms, MCP_WIDGET_TOOLS.fares];

export const MCP_RESULTS_TTL_MS = 15 * 60 * 1000;

export const MCP_HANDOFF_SECRET_BYTES = 32;

export const MCP_BOOK_SUMMARY_MAX_CHARS = 500;

export const MCP_CONTINUE_PATH = "/continue";

export const MCP_CONTINUE_UTM = { utm_medium: "mcp", utm_campaign: "connector" } as const;

export const MCP_WIDGET_SYSTEM_FONT =
  'system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif';

export const MCP_WIDGET_HOST_FONT_VARIABLE = "--font-sans" as const;

export const MCP_WIDGET_HOST_BACKGROUND_VARIABLE = "--color-background-primary" as const;

export const MCP_WIDGET_APP_CONFIG: iAppConfig[] = [
  {
    id: "mcp-widget-show-fare-family",
    key: "show_fare_family",
    value: "true",
    description: "",
    status: true,
    createdAt: "",
    updatedAt: "",
    deletedAt: null,
  },
];

export const MCP_HANDOFF_SECRET_KEY = "mcp_handoff_secret";
